<template>
  <div class="work_detail">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img v-if="URL_MAQIN == 2" src="../assets/img/kjc返回.png" alt />
          <img v-if="URL_MAQIN == 1" src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <div class="jion clearfix" @click="join_click">
          <img src="../assets/img/add.png" alt />
          加入班群
        </div> -->
      </div>

      <!-- 内容区域 -->
      <div class="content_box clearfix">
        <!-- 左侧 -->
        <div class="content_box_l">
          <div class="content_box_l_title">已报课程</div>
          <div
            class="class_list"
            :class="item.title == title ? 'active' : ''"
            v-for="(item, index) in title_list"
            :key="index"
            @click="chuange_class(item.course_id, item.chapter_id, item.title)"
          >
            {{ item.title }}
          </div>
          <a href="https://im.mifengdao.com/?is_study=1" target="_blank">
            <button style="width: 208px;height: 46px;background: #FADA1E;border-radius: 23px;border:none;position:absolute;bottom:-78px;left:30px;display:flex;justify-content:center;align-items:center;cursor:pointer">
              <img src="@/assets/img/teacher.png" alt="" style="width:23px;height:23px;margin-right:11px">问老师
            </button>
          </a>
        </div>

        <!-- 右侧 -->
        <div class="content_box_r">
          <div class="container1">
            <div
              class="left"
              v-if="questionsList && questionsList.course_info.title"
            >
              <div class="title">{{ questionsList.course_info.title }}</div>
              <p>有效时间：{{ questionsList.expire_time }}</p>
              <button @click="join_click">
                <img src="../assets/img/add2.png" alt="" />{{addClassContent?addClassContent.title:'添加助教'}}
              </button>
              
            </div>
            <div class="right">
              <div
                class="examTime"
                v-if="examTime && examTime.has_exam_date != 0"
              >
                <img src="../assets/img/djs.png" alt="" />
                距离考试还有<span>{{ examTime.exam_time }}</span
                >天，抓紧时间学习啦～
              </div>
              <div class="over_lore clearfix" style="display:flex;margin-top:28px">
                    <div class="name">知识点：</div>
                    <div class="proge" style="width:70%;margin:0 10px">
                      <el-progress :percentage="progress1" :show-text="false" :stroke-width="18"></el-progress>
                    </div>
                    <div class="number" v-if="questionsList">
                      <span>{{questionsList.knowledge_data.do_count}}</span>/{{questionsList.knowledge_data.total_count}}
                    </div>
                </div>
                <div class="over_lore clearfix" style="display:flex;margin-top:28px">
                    <div class="name">总题目：</div>
                    <div class="proge1" style="width:70%;margin:0 10px">
                        <el-progress :percentage="progress2" :show-text="false" :stroke-width="18"></el-progress>
                    </div>
                    <div class="number" v-if="questionsList">
                      <span>{{questionsList.question_data.do_count}}</span>/{{questionsList.question_data.total_count}}
                    </div>
                </div>
            </div>
          </div>
          <div class="container2">
            <div class="left">
              <div class="bigBox">
                <div
                  class="block"
                  v-for="item in questionsList.big_list"
                  @click="goPage(item)"
                >
                  <p>{{ item.title }}</p>
                  <span>{{ item.pc_description || "无" }}</span>
                  <div class="bottom">
                    <img :src="item.pc_thumb" alt="" />
                    <button>进入学习</button>
                  </div>
                </div>
              </div>
              <div class="smallBox">
                <div
                  class="block"
                  v-for="item in questionsList.small_list1"
                  @click="goPage(item)"
                >
                  <img :src="item.pc_thumb" alt="" />
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="right">
              <div class="title">练习数据</div>
              <div
                class="row"
                v-for="item in questionsList.small_list2"
                @click="goPage(item)"
              >
                <img :src="item.pc_thumb" alt="" />
                {{ item.title }}
                <span v-if="item.ai_type==4">{{item.wrong_count}}</span>
                <span v-if="item.ai_type==5">{{item.favorite_count}}</span>
                <span v-if="item.ai_type==6">{{item.comment_count}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Questions, ClassTitle, ExamTime,levelContent } from "@/api/index";
import appConfig from "@/api/appConfig";
export default {
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      questionsList: "",
      examTime: "",
      top_show: false,
      title_list: [],
      title: "",
      progress1:0,
      progress2:0,
      addClassContent:'',
    };
  },
  created() {
    let course_id = sessionStorage.getItem("course_id");
    let chapter_id = sessionStorage.getItem("chapter_id");
    this.QuestionsM();
    this.ExamTimeM();
    this.joinClass()
  },
  beforeRouteEnter(to, from, next) {
    console.log(to,from)
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/knowledgeStudy") {
      to.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    // 加入班群
    joinClass(){
      levelContent(this.$route.query.course_id,13).then(res=>{
        this.addClassContent = res
      })
    },
    ExamTimeM() {
      ExamTime(this.$route.query.course_id).then((res) => {
        this.examTime = res;
      });
    },
    close_overlay() {
      this.top_show = false;
      this.show = false;
    },
    // 点击顶部切换课程
    chuange_class(course_id, chapter_id, title) {
      this.QuestionsM(course_id, chapter_id);
      this.top_show = false;
      sessionStorage.setItem("course_id", course_id);
      sessionStorage.setItem("chapter_id", chapter_id);
    },
    QuestionsM(
      course_id = this.$route.query.course_id,
      chapter_id = this.$route.query.chapter_id
    ) {
      Questions(course_id, chapter_id||0).then((res) => {
        this.questionsList = res;
        // 进度条
        this.progress1 = (this.questionsList.knowledge_data.do_count/this.questionsList.knowledge_data.total_count*100)
        this.progress2 = (this.questionsList.question_data.do_count/this.questionsList.question_data.total_count*100)
      });
      ClassTitle(course_id).then((res) => {
        console.log(res);
        this.title_list = res;
        if (course_id == 0) {
          this.title = this.title_list[0].title;
        } else {
          for (let i = 0; i < this.title_list.length; i++) {
            if (this.title_list[i].chapter_id == chapter_id) {
              this.title = this.title_list[i].title;
            }
          }
        }
      });
    },
    // 顶部下拉
    top_click() {
      if (this.title_list.length > 1) {
        this.top_show = !this.top_show;
      }
    },
    // 加入班群
    join_click() {
      this.$router.push({
        path: "join",
        query: {
          chapter_id: this.$route.query.chapter_id,
          course_id: this.$route.query.course_id,
          type: "加入班群",
        },
      });
    },
    // 前往页面
    goPage(item) {
      if (item.ai_type === 0) {
        // 原有的课程做题
        if (item.level_type == 3) {
          this.$router.push({
            path: "exam_list",
            query: {
              course_id: item.course_id,
              id: item.id,
              title: item.title,
              toptitle: this.title,
              learn_type:this.questionsList.course_info.learn_type
            }
          });
        } else {
          this.$router.push({
            path: "exercise_list",
            query: {
              course_id: item.course_id,
              id: item.id,
              title: item.title,
              chapter_id: this.$route.query.chapter_id,
            },
          });
        }

      } else if (item.ai_type === 1) {
        //薄弱知识点(蜂狂训练营)
        this.$router.push({
          path: "/brzsd",
          query: {
            course_id: item.course_id,
            id: item.id,
            chapter_id: this.$route.query.chapter_id,
          },
        });
      } else if (item.ai_type === 2) {
        //组卷模考
        this.$router.push({
          path: "mockZujuan",
          query: {
            course_id: item.course_id,
            id: item.id,
            title: item.title,
            chapter_id: this.$route.query.chapter_id,
          },
        });
      } else if (item.ai_type === 3) {
        //知识点学习
        this.$router.push({
          path: "/knowledgeStudy",
          query: {
            course_id: item.course_id,
            id: item.id,
            chapter_id: this.$route.query.chapter_id,
          },
        });
      } else if (item.ai_type === 4) {
        //错题本
        this.$router.push({
          path: "wrongTopic",
          query: {
            subject_id: item.id,
            chapter_id: this.$route.query.chapter_id,
            type: 1,
          },
        });
      } else if (item.ai_type === 5) {
        //收藏夹
        // this.$router.push({
        //   path: "assemble",
        //   query: {
        //     subject_id: item.id,
        //     chapter_id: this.$route.query.chapter_id,
        //     type: 2,
        //     is_zsd:1,
        //   }
        // });
        this.$router.push({
          path: "collectTopic",
          query: {
            subject_id: item.id,
            chapter_id: this.$route.query.chapter_id,
            type: 2,
          },
        });
      } else if (item.ai_type === 6) {
        //提问记录
        this.$router.push({
          path: "my_questions",
          query: { course_id: item.id, id: this.$route.query.chapter_id }
        });
        // location.href = `${appConfig.ShoppUrl}/ask/courseComment?courseID=${item.course_id}&subjectID=${item.id}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
    .jion {
      cursor: pointer;
      float: right;
      line-height: 24px;
      padding-right: 24px;
      img {
        float: left;
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
  }
  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      position: relative;
      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }
      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: rgba(250, 220, 30, 1);
      }
    }
    .content_box_r {
      float: right;
      width: 1067px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      .container1 {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;
        padding: 34px 41px 24px 41px;
        box-sizing: border-box;
        .left {
          .title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }
          p {
            margin-top: 18px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #666666;
          }
          button {
            width: 128px;
            height: 41px;
            background: #fada1e;
            border-radius: 20px;
            margin-top: 40px;
            border: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
              width: 15px;
              margin-right: 11px;
            }
          }
        }
        .right {
          .examTime {
            margin-top: 20px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            display: flex;
            align-items: center;
            width: 480px;
            img {
              width: 28px;
              margin-right: 14px;
            }
            span {
              color: #e84233;
            }
          }
        }
      }
      .container2 {
        padding: 24px 0 0 34px;
        display: flex;
        justify-content: space-between;
        .left {
          .bigBox {
            overflow: hidden;
            .block {
              width: 295px;
              height: 169px;
              background: #f7f7f7;
              border: 1px solid #eeeeee;
              margin-right: 25px;
              float: left;
              padding-left: 12px;
              box-sizing: border-box;
              cursor: pointer;
              p {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                margin-top: 12px;
              }
              span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                margin-top: 4px;
              }
              .bottom {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 14px;
                img {
                  width: 77px;
                  height: 77px;
                }
                button {
                  width: 102px;
                  height: 30px;
                  background: #fada1e;
                  border-radius: 19px;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  border: 0;
                  margin-right: 24px;
                  cursor: pointer;
                }
              }
            }
          }
          .smallBox {
            overflow: hidden;
            padding-bottom: 100px;
            .block {
              margin-top: 24px;
              margin-right: 24px;
              width: 189px;
              height: 104px;
              background: #f7f7f7;
              border-radius: 11px;
              display: flex;
              justify-content: space-around;
              align-items: center;
              float: left;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              cursor: pointer;
              img {
                width: 46px;
                height: 46px;
              }
            }
          }
        }
        .right {
          width: 344px;
          box-sizing: border-box;
          border-left: 1px solid #eeeeee;
          padding: 0 29px 0 16px;
          margin-bottom: 43px;
          .title {
            margin-bottom: 32px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            position: relative;
            &::before {
              position: absolute;
              content: "";
              width: 71px;
              height: 8px;
              background: #fada1e;
              left: 0;
              bottom: -14px;
            }
          }
          .row {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            display: flex;
            align-items: center;
            height: 66px;
            border-bottom: 1px solid #eeeeee;
            cursor: pointer;
            position: relative;
            img {
              width: 36px;
              height: 36px;
              margin-right: 16px;
            }
            span{
              position: absolute;
              right: 0;
            }
          }
        }
      }
    }
  }
}
.work_detail {
  margin-bottom: 150px;
}
</style>
<style lang="scss">
.main_mfd {
  .el-progress-bar__inner {
    background-color: #fadc1e;
  }
}
.adImg {
  width: 100%;
  font-size: 0;
  cursor: pointer;
  img {
    width: 100%;
  }
}
</style>
